export const Button = ({
  onClick,
  children,
  isInvalid,
  classes,
  disable,
  onMouseDown
}) => {
  return (
    <button
      className={`${
        classes ? classes : "flex items-center justify-center gap-2"
      }`}
      onClick={onClick}
      disabled={isInvalid}
      onMouseDown={onMouseDown}
    >
      {children}
    </button>
  );
};
